import { useStore } from "@/stores/useStore.ts";
import { Outlet } from "react-router-dom";

export const AdminLayoutPage = () => {
  const role = useStore((s) => s.authRoles);

  if (!role?.superAdmin) {
    return <div>403 - Forbidden</div>;
  }

  return <Outlet />;
};
